// import library
import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from"moment";
// import components
import Layout from "../../layouts/Layout";
import LoaderIcon from "../../components/Common/Icon/Loader";
// import files
import { env } from "../../env";
import { logEvent } from "../../analytics";

const LastOrderIndex = () => {
    // variables
    const { t } = useTranslation();
    const [isLoader, setIsLoader] = useState(true);
    const [orders, setOrders] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [showAction, setShowAction] = useState(false);
    const [actionKey, setActionKey] = useState(0);
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    // functions
    useEffect(() => {
        const requestData = {
            page_num : 1,
            page_size : 1,
            sort_by : 'orderid',
            sort_order : "desc",
            search_term : "",
            month_info: "0",
            order_status: "",
            order_date: ""
        }
        getOrderHistoryListApi(requestData);
    }, []);

    const getOrderHistoryListApi = async(data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "application/json",
            "Content-Type" : "application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+"/api/OfflineSync/GetOrderListSearch", data, {headers})
        .then((response) => {
            if(!response.data.success) {
                setOrders(response.data);
            }
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const openAction = (e, index) => {
        e.preventDefault();
        if(actionKey === index) {
            setShowAction(!showAction);
        } else {
            setShowAction(true);
        }
        setActionKey(index);
    };
    const handleLog = (id) => {
        logEvent('last_order_history_page', 'last_order', 'redirect_to_order_detail', id);
    };

    return  (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="sm:text-2xl font-semibold capitalize">{ t('last order') }</h1>
                        <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('orders') } / { t('last order') }</p>
                    </div>
                </div>
                { isLoader
                    ? 
                        <LoaderIcon />
                    :
                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4 shadow-around">
                            <div className="sm:block hidden relative overflow-x-auto shadow-md rounded-lg">
                                {/* table */}
                                <table className="w-full text-xs">
                                    <thead className="text-gray-normal bg-background-normal">
                                        <tr>
                                            <th scope="col" className="font-normal p-4 w-1/5">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('customer name') }
                                                    </div>
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('order number') }
                                                    </div>
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('ordered date') }
                                                    </div>
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('quantity') }
                                                    </div>
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('status') }
                                                    </div>
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4 uppercase text-left">
                                                { t('actions') }
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    { orders.list.length > 0 ?
                                        (orders.list).map((row, index) => (
                                            <tr key={'order'+row.orderid} className="bg-white border-b hover:bg-gray-50 ">
                                                <td className="p-4 text-light-400">
                                                    {row.customername ? row.customername : 'NA'}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.orderid}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.orderdate ? moment(row.orderdate).format("DD/MM/YYYY") : 'NA'}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {formatter.format(row.totalqty)}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.order_Status ?
                                                        <div
                                                            style={{ color: row.statuscolor, backgroundColor: row.statuscolor + '20' }}
                                                            className="px-4 py-2 border rounded text-center font-medium capitalize"
                                                        >
                                                            { t(row.order_Status.toLowerCase())}
                                                        </div>
                                                        : 'NA'
                                                    }
                                                </td>
                                                <td className="p-4">
                                                    <div className="flex flex-col items-center relative">
                                                        <img className={showAction && actionKey === (row.orderid) ? "bg-background-normal p-3 rounded-full" : null + " cursor-pointer"} src="../../assets/icons/table/vertical-dot.svg" onClick={(e) => openAction(e, row.orderid)} alt="dot" />
                                                        {
                                                            showAction && actionKey === (row.orderid)
                                                            ? 
                                                                <div className="absolute w-max right-[3.2rem] top-1 bg-white border border-white shadow-md rounded">
                                                                    <ul>
                                                                        <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded" onClick={handleLog(row.orderid)}>
                                                                            <NavLink to={`/order/history/${row.orderid}`} className="capitalize flex">
                                                                                { t('view') }
                                                                            </NavLink>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            : null
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        )) 
                                            : null
                                        }
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {  orders.list.length === 0
                                    ?
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t('no data available')}
                                    </div>
                                    : 
                                        null   
                                }
                            </div>
                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                {(orders.list.length > 0) ?
                                    <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                        { orders.list.map((row, index) => (
                                            <div key={'order'+row.orderid} className=" border border-action-hover bg-action-hover rounded-[10px] p-2 space-y-2">
                                                <div className="space-y-1">
                                                    <div>
                                                        <div className="flex justify-between items-center">
                                                            <div className="font-medium text-base">{row.customername ? row.customername : 'NA'}</div>
                                                            <div className="flex flex-col items-center relative">
                                                                <img className="cursor-pointer" src="../../assets/icons/table/vertical-dot.svg" onClick={(e) => openAction(e, row.orderid)} alt="dot" />
                                                                {
                                                                    showAction && actionKey === (row.orderid)
                                                                    ? 
                                                                        <div className="absolute w-max right-[1.2rem] top-1 bg-white border border-white shadow-md rounded">
                                                                            <ul>
                                                                                <li className="hover:bg-action-hover px-2 py-1 text-xs hover:rounded" onClick={handleLog(row.orderid)}>
                                                                                    <NavLink to={`/order/history/${row.orderid}`} className="capitalize flex">
                                                                                        { t('view') }
                                                                                    </NavLink>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="text-light-400 text-xs">
                                                            <span className="capitalize">{ t('order id')} : </span><span className="font-medium">{row.orderid}</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex text-sm items-center justify-between">
                                                        <div className="flex text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                            <div className="font-bold ml-2">{formatter.format(row.totalqty)}</div>
                                                        </div>
                                                        <div className="flex text-sm text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('status')}:</h1>
                                                            <td className="p-4 text-light-400">
                                                                {row.order_Status ?
                                                                    <div
                                                                        style={{ color: row.statuscolor, backgroundColor: row.statuscolor + '20' }}
                                                                        className="px-4 py-2 border rounded text-center font-medium capitalize"
                                                                    >
                                                                        { t(row.order_Status.toLowerCase())}
                                                                    </div>
                                                                    : 'NA'
                                                                }
                                                            </td>
                                                        </div>
                                                    </div>
                                                    <div className="flex text-sm text-light-400 items-center">
                                                        <h1 className="capitalize font-medium">{ t('ordered date')}:</h1>
                                                        <div className="font-bold ml-2">{row.orderdate ? moment(row.orderdate).format("DD/MM/YYYY") : 'NA'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    : null
                                }
                                
                            </div>
                        </div>
                }
            </div>
        </Layout>
    )
}

export default LastOrderIndex;